/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ ready: NonNullable<unknown>, total: NonNullable<unknown>, portions: NonNullable<unknown> }} Cook_Ready_ForInputs */

const en_cook_ready_for = /** @type {(inputs: Cook_Ready_ForInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.ready} of ${i?.total} ready · for ${i?.portions}`)
};

const de_cook_ready_for = /** @type {(inputs: Cook_Ready_ForInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.ready} von ${i?.total} bereit · für ${i?.portions}`)
};

/**
* | output |
* | --- |
* | "{ready} of {total} ready · for {portions}" |
*
* @param {Cook_Ready_ForInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cook_ready_for = /** @type {((inputs: Cook_Ready_ForInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cook_Ready_ForInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cook_ready_for(inputs)
	return en_cook_ready_for(inputs)
});